import { createSelector } from '@reduxjs/toolkit'
import { StoreState } from '../index'
import { CompanyTypeRS } from '../../types/Company'

const companySelector = (state: StoreState) => state.company
export const CompanySelectors = {
  company: createSelector([companySelector], (state) => state.company),
  clients: createSelector([companySelector], (state) => state.clients),
  clientDetails: createSelector([companySelector], (state) => state.clientDetails),
  countInvitations: createSelector(
    [companySelector],
    (state) => state.clients.filter((client) => client.isInviter && !client.isAccepted).length
  ),
  users: createSelector([companySelector], (state) => state.users),
  bankSearchResults: createSelector([companySelector], (state) => state.bankSearchResults),
  bankBranchSearchResults: createSelector([companySelector], (state) => state.bankBranchSearchResults),
  inviteToken: createSelector([companySelector], (state) => state.inviteToken),
  invoiceLicenseCompanyName: createSelector([companySelector], (state) => state.invoiceLicenseCompanyName),
  membershipFeeName: createSelector([companySelector], (state) => state.company?.membershipFee?.name ?? '協力会費'),
  membershipFee: createSelector([companySelector], (state) => state.membershipFee),
  csvImportSetting: createSelector([companySelector], (state) => state.csvImportSetting),
  isRS: createSelector([companySelector], (state) => state.company?.type === CompanyTypeRS),
  representatives: createSelector([companySelector], (state) => state.representatives),
  representative: createSelector([companySelector], (state) => state.representative),
  branchOffices: createSelector([companySelector], (state) => state.branchOffices),
  projectDetail: createSelector([companySelector], (state) => state.projectDetail),
  visitorRegistrationForm: createSelector([companySelector], (state) => state.visitorRegistrationForm),
  visitorRegistrationFormWorkers: createSelector([companySelector], (state) => state.visitorRegistrationFormWorkers),
  visitorRegistrationFormSubcontractors: createSelector(
    [companySelector],
    (state) => state.visitorRegistrationFormSubcontractors
  ),
  visitorRegistrationRecordSet: createSelector([companySelector], (state) => state.visitorRegistrationRecordSet),
  isSubmittedIdentity: createSelector(
    (state: StoreState) => state,
    (state) => {
      if (state.company.company?.representative && state.session.user) {
        if (state.company.company.representative.userId !== state.session.user.id) {
          return undefined
        }
        return state.company.company.representative.submittedAt !== null
      }
      return undefined
    }
  ),
  agreementSettings: createSelector([companySelector], (state) => state.agreementSettings),
}
